module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['dof-btn-panel'],
    style: {
      'background-color': this.bgColor
    },
    attrs: {
      "accessible": true,
      "ariaLabel": _vm.text
    }
  }, [_c('div', {
    staticClass: ["btn-group-wrap"],
    style: _vm.wrapStyle
  }, _vm._l((_vm.btnGroup), function(text, index) {
    return _c('text', {
      key: index,
      class: [
        'btn-text',
        !_vm.disabled && _vm.pattern === 'text' &&
        ("dof-text-highlight-" + _vm.type)
      ],
      style: [index < _vm.btnGroup.length - 1 ? _vm.verticalLineStyle : '', _vm.textStyle, index == _vm.selectIndex ? _vm.textBtnStyle : ''],
      attrs: {
        "dataIndex": index
      },
      on: {
        "click": function($event) {
          _vm.onTextClicked(index)
        }
      }
    }, [_vm._v(_vm._s(text))])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5909cc86!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-button-group/index.vue
// module id = 612
// module chunks = 0 1